/**
 * @generated SignedSource<<16527999e3ebdeb487e2cceb074e085e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PresentationVideoPlayer_presentation$data = {
  readonly videoSourceUrl: string | null | undefined;
  readonly " $fragmentType": "PresentationVideoPlayer_presentation";
};
export type PresentationVideoPlayer_presentation$key = {
  readonly " $data"?: PresentationVideoPlayer_presentation$data;
  readonly " $fragmentSpreads": FragmentRefs<"PresentationVideoPlayer_presentation">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PresentationVideoPlayer_presentation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "videoSourceUrl",
      "storageKey": null
    }
  ],
  "type": "Presentation",
  "abstractKey": null
};

(node as any).hash = "59fa79e6e85b9dcaf4f1a6b9b2a7acf4";

export default node;
